export { default } from './app'



// WEBPACK FOOTER //
// ./src/components/app/index.js